import {
  MaterialUICore,
  Body as DSBody,
  axiomTokens,
  TextField as DSTextField,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing, font, color, border } = axiomTokens;

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const FieldsWrapper = styled('div')({
  gap: spacing[4],
  gridTemplateColumns: '1.3fr 1fr 1fr',
  gridTemplateAreas: `
    "phone cep cepHelper"
    "address address number"
    "complement neighborhood neighborhood"
    "city city state"
  `,
  display: 'grid',
});

export const TextComplement = styled(DSTextField)(({ theme }) => ({
  gridArea: 'complement',

  [theme.breakpoints.down('xs')]: {
    marginRight: '-6px',
  },
}));

export const CepHelper = styled('a')({
  gridArea: 'cepHelper',
  fontSize: font.size.xxs,
  textDecoration: 'none',
  fontWeight: font.weight.medium,
  letterSpacing: '0.72px',
  alignSelf: 'center',
  cursor: 'pointer',
  width: 'fit-content',
  color: color.typeface.feedback.info,
  '&:hover': {
    textDecoration: 'none',
  },
});

export const BodyDescription = styled(DSBody)(() => ({
  textAlign: 'start',
  fontFamily: font.family.base,
  fontWeight: font.weight.regular,
  fontSize: font.size.xxxs,
  lineHeight: '132%',
  letterSpacing: '1px',
  backgroundColor: color.surface.accent.default,
  padding: `${spacing[1]} ${spacing[2]}`,
  borderRadius: border.radius.md,
}));

export const CheckboxWrapper = styled('div')({
  gap: '19px',
  display: 'flex',
  flexDirection: 'column',

  '&.error .MuiIconButton-label': {
    color: color.typeface.feedback.alert,
  },

  '&.error .MuiFormControlLabel-label': {
    color: color.typeface.feedback.alert,
  },
});
